"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const conversionUtils_1 = require("../../conversionUtils");
const uinode_1 = require("../generated-loan-tape/uinode");
const types_1 = require("./types");
const uinode_2 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_2.file_generatedCovenantLoanTape.isIntermediateRecord(tape), `intermediateToUINodes: expected ${types_1.artifactType} but found [artifactType:${tape.type}]`);
    const { id: tapeBuilderNodeId, creditFacilitySlug, configuration, artifactSlug, } = tape;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            creditFacilitySlug,
            ...configuration,
        },
    };
    return {
        operationNode: null,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node, graph } = params;
    (0, common_1.finleyAssert)(uinode_2.file_generatedCovenantLoanTape.isNode(node), `uiNodesToIntermediate: node is not a generatedCovenantLoanTape [nodeType:${node.metadata.tapeBuilderNodeType}]`);
    const { srcTapes } = (0, conversionUtils_1.getOperationAndTapes)({ node, graph });
    const generatedLoanTape = srcTapes.find(uinode_1.file_generatedLoanTape.isNode);
    (0, common_1.finleyAssert)(generatedLoanTape, 'uiNodesToIntermediate: generatedLoanTape srcTape is null for generatedCovenantLoanTape');
    const { artifactSlug, creditFacilitySlug, ...configuration } = node.configuration;
    const { loanProductSlug } = generatedLoanTape.configuration;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug,
        externalFilename: null,
        configuration,
    };
    return {
        record,
        operationNode: null,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map